<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="text-2xl font-bold primaryColor" i18n="@@addcity">Add city</h1>
  </div>
</div>
<div class="mb-4 rounded-2xl p-[16px]">
  <app-create-city-component/>
</div>
